import { render, staticRenderFns } from "./newsInformation.vue?vue&type=template&id=3d820114&scoped=true"
import script from "./newsInformation.vue?vue&type=script&lang=js"
export * from "./newsInformation.vue?vue&type=script&lang=js"
import style0 from "./newsInformation.vue?vue&type=style&index=0&id=3d820114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d820114",
  null
  
)

export default component.exports